import { AxiosError } from '@vtblife/axios';

export const getGrpcErrorMessage = (error: AxiosError) => {
    const grpcMessage = error.response?.headers['grpc-message'];
    return grpcMessage ? decodeURI(grpcMessage) : '';
};
